import WordSetting from "./WordSetting";
import SentenceSetting from "./SentenceSetting";
import VideoSetting from "./VideoSetting";
import { Button, ButtonReversed } from "shared/components/Button";
import { setting } from "shared/types/Report";
import useHomeworkSettingView from "features/homework/hooks/useHomeworkSettingView";
import { BatchBackdrop, BatchModal, BatchHeader, BatchTitle, BatchDesc, BatchBody, BatchFooter } from "../homeworkUi";

interface hasContent{
    word:boolean,
    sentence:boolean,
    video:boolean,
  }


interface SettingViewProps {
    isOpen: boolean,
    setting: setting | undefined,
    setSetting: React.Dispatch<React.SetStateAction<setting | undefined>>,
    onSettingCancelClickHandler: () => void,
    onSettingInputCompleteClickHandler: () => void,
    isContentAvailable:hasContent | undefined
}

const HomeworkSettingModal = ({ isOpen, isContentAvailable, setting, setSetting, onSettingCancelClickHandler, onSettingInputCompleteClickHandler }: SettingViewProps) => {
    const { onSettingChangeHandler } = useHomeworkSettingView(setSetting);

    const viewOptions = (name: string, max: number, unit: string) => {
        const option_list: any = [];

        for (let i = 1; i <= max; i++) {
            const value = unit === "%" ? i * 10 : i;
            option_list.push(<option key={i} value={value}>{`${name} ${value}${unit}`}</option>)
        }
        return option_list;
    }

    if (!isOpen || !setting) {
        return null;
    }

    return (
        <BatchBackdrop>
            <BatchModal>
                <BatchHeader>
                    <BatchTitle>학습 설정</BatchTitle>
                    <BatchDesc>콘텐츠별 학습 방식을 고른 뒤 저장하면 배포에 반영됩니다.</BatchDesc>
                </BatchHeader>
                <BatchBody>
                    {isContentAvailable?.word ? <WordSetting viewOptions={viewOptions} setting={setting} onSettingChangeHandler={onSettingChangeHandler} /> : null}
                    {isContentAvailable?.sentence ? <SentenceSetting viewOptions={viewOptions} setting={setting} onSettingChangeHandler={onSettingChangeHandler} /> : null}
                    {isContentAvailable?.video ? <VideoSetting viewOptions={viewOptions} setting={setting} onSettingChangeHandler={onSettingChangeHandler} /> : null}
                </BatchBody>
                <BatchFooter>
                    <ButtonReversed name="취소" onButtonClick={onSettingCancelClickHandler} />
                    <Button name="저장" onButtonClick={onSettingInputCompleteClickHandler} />
                </BatchFooter>
            </BatchModal>
        </BatchBackdrop>
    )
}

export default HomeworkSettingModal;
